import {Link} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/link.types';
import {Breadcrumbs} from '@aboutyou/ui-components';
import React from 'react';

interface HelpCenterBreadcrumbsProps {
  breadcrumbs: Link[];
}

export const HelpCenterBreadcrumbs = ({
  breadcrumbs,
}: HelpCenterBreadcrumbsProps) => {
  return (
    <Breadcrumbs
      links={breadcrumbs.map(breadcrumb => ({
        label: breadcrumb.label,
        path: breadcrumb.linkTarget.url,
      }))}
    />
  );
};
